import { useCallback, useEffect, useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";

const PLANS = ["Starter", "Professional", "Enterprise"];
const PLAN_PRICE = { Starter: 29, Professional: 79, Enterprise: 199 };

const STYLES = {
  Starter: "bg-[#F1F5F9] text-[#475569] border-[#CBD5E1]",
  Professional: "bg-[#DCFCE7] text-[#14532D] border-[#86EFAC]",
  Enterprise: "bg-[#FEF3C7] text-[#92400E] border-[#FBBF24]",
};

export default function AdminSubscriptions() {
  const [users, setUsers] = useState([]);

  const load = useCallback(() => client.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const setPlan = async (uid, plan) => {
    await client.post(`/admin/users/${uid}/plan`, { plan });
    toast.success("Plan updated");
    load();
  };

  return (
    <div data-testid="admin-subscriptions-page">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#64748B] mb-1">Admin · Subscriptions</div>
      <h1 className="trent-heading text-3xl md:text-4xl font-black tracking-tighter text-[#0F172A] mb-6">
        Subscriptions
      </h1>

      <div className="bg-white border border-[#E5E7EB] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-[10px] uppercase tracking-[0.2em] text-[#64748B]">
            <tr>
              <th className="text-left px-4 py-3">Customer</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Email</th>
              <th className="text-left px-4 py-3">Current plan</th>
              <th className="text-left px-4 py-3">Change plan</th>
              <th className="text-right px-4 py-3">MRR</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => {
              const plan = u.plan || "Starter";
              return (
                <tr key={u.id} className="border-t border-[#E5E7EB]" data-testid={`sub-row-${u.id}`}>
                  <td className="px-4 py-3 font-semibold">{u.name}</td>
                  <td className="px-4 py-3 hidden md:table-cell text-[#475569]">{u.email}</td>
                  <td className="px-4 py-3">
                    <span className={`condition-pill ${STYLES[plan]}`}>{plan}</span>
                  </td>
                  <td className="px-4 py-3">
                    <select value={plan} onChange={(e) => setPlan(u.id, e.target.value)} className="trent-input py-1" data-testid={`sub-change-${u.id}`}>
                      {PLANS.map((p) => <option key={p}>{p}</option>)}
                    </select>
                  </td>
                  <td className="px-4 py-3 text-right font-semibold">€{PLAN_PRICE[plan] || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
